const SHOW_DELETE_SCRATCH_APP_KEY = 'designstudio.showDeleteScratchAppMenu';

let memoryPreference: boolean | undefined;

type LocalStorageLike = {
  readonly getItem: (key: string) => string | null;
  readonly setItem: (key: string, value: string) => void;
  readonly removeItem: (key: string) => void;
};

function readStorage(): LocalStorageLike | undefined {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }
  try {
    const storage = (globalThis as { readonly localStorage?: LocalStorageLike }).localStorage;
    if (storage === undefined) {
      return undefined;
    }
    const probeKey = `${SHOW_DELETE_SCRATCH_APP_KEY}.probe`;
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch {
    return undefined;
  }
}

/** Soft-hide for destructive “Delete app” on independent tiles (default: hidden). */
export function readShowDeleteScratchAppMenu(): boolean {
  const storage = readStorage();
  if (storage !== undefined) {
    return storage.getItem(SHOW_DELETE_SCRATCH_APP_KEY) === '1';
  }
  return memoryPreference === true;
}

export function writeShowDeleteScratchAppMenu(enabled: boolean): void {
  const storage = readStorage();
  if (storage !== undefined) {
    if (enabled) {
      storage.setItem(SHOW_DELETE_SCRATCH_APP_KEY, '1');
    } else {
      storage.removeItem(SHOW_DELETE_SCRATCH_APP_KEY);
    }
  }
  memoryPreference = enabled ? true : undefined;
}
